import React from 'react';
import { Divider } from 'rsuite';
import { Eshop } from '../../../api/eshop/eshop';
import EshopSetupDetail, { Input, Labels } from '../EshopSetupDetail';
import EshopSetupKauflandTransportMapping from './EshopSetupKauflandTransportMapping';
import EshopSetupKauflandWarehouses from './EshopSetupKauflandWarehouses';
import EshopSetupCrossDock from '../EshopSetupCrossDock';
import EshopSetupPricing from '../EshopSetupPricing';
import EshopSetupPartnerSalesEntity from '../EshopSetupPartnerSalesEntity';

interface Props {
  eshop: Eshop;
  onUpdate: () => void
}

const labels: Labels = {
  clientKey: 'Client key',
  clientSecret: 'Client secret',
  stockThreshold: 'Stock threshold',
  expeditionDays: 'Expedition days',
  fixedFee: '',
  dynamicBranchId: '',
  substitutedPhoneNumber: 'Substitute for an empty phone number',
  packetaId: '',
  packetaApiKey: '',
  invoiceRequired: 'Invoice automatic generation',
  creditNoteRequired: 'Credit Note automatic generation',
};

const inputs: Input[] = [
  Input.SYNCHRONIZATION,
  Input.CLIENT_KEY,
  Input.CLIENT_SECRET,
  Input.STOCK_THRESHOLD,
  Input.EXPEDITION_DAYS,
  Input.SUBSTITUTED_PHONE_NUMBER,
  Input.INVOICE_REQUIRED,
  Input.CREDIT_NOTE_REQUIRED,
];

export default function EshopSetupKaufland({ eshop, onUpdate }: Props) {
  return (
    <>
      <EshopSetupDetail eshop={eshop} labels={labels} inputs={inputs} onSuccessfulSave={onUpdate} />
      <Divider>Warehouses</Divider>
      <EshopSetupKauflandWarehouses eshop={eshop} />
      <Divider>Shipping groups</Divider>
      <EshopSetupKauflandTransportMapping eshop={eshop} />
      <Divider>Cross dock</Divider>
      <EshopSetupCrossDock eshop={eshop} />
      <Divider>Pricing</Divider>
      <EshopSetupPricing eshop={eshop} />
      <Divider>Partner&apos;s business entity</Divider>
      <EshopSetupPartnerSalesEntity eshop={eshop} />
    </>
  );
}
